module.exports = __webpack_public_path__ + "static/img/icon-left-choose.503c4faa.png";